import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { id: "mainContainer" }
const _hoisted_2 = { class: "mid-container" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = {
  id: "tabsFixed",
  class: "fold-menu-section"
}
const _hoisted_5 = { class: "container" }
const _hoisted_6 = { class: "custom-row" }
const _hoisted_7 = { class: "fold_menu" }
const _hoisted_8 = { id: "teleporter" }
const _hoisted_9 = ["id", "onClick"]
const _hoisted_10 = ["id"]
const _hoisted_11 = { class: "container clearfix b-f-left" }
const _hoisted_12 = { class: "big-picture" }
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  class: "picture-content showcontent",
  id: "readMoewaa"
}
const _hoisted_15 = { class: "fold-txt-box" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { class: "b_p_txt" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = {
  key: 0,
  class: "page_link"
}
const _hoisted_20 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_userHeader = _resolveComponent("userHeader")!
  const _component_userFooter = _resolveComponent("userFooter")!
  const _component_ChatbotPopup = _resolveComponent("ChatbotPopup")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_userHeader),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("section", {
        class: "page-banner-section",
        style: _normalizeStyle({ 'background-image': `url(${require('@/assets/images/industry-banner-img.jpg')})` })
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.constants['INDUSTRY_FOCUS_TEXT']), 1)
        ])
      ], 4),
      _createElementVNode("section", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("ul", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.industriesData, (industries, index) => {
                  return (_openBlock(), _createElementBlock("li", { key: index }, [
                    _createElementVNode("a", {
                      href: "javascript:void(0);",
                      id: `tabs${index.toString()}`,
                      onClick: ($event: any) => (_ctx.scrollToSection(industries.id))
                    }, _toDisplayString(industries.title), 9, _hoisted_9)
                  ]))
                }), 128))
              ])
            ]),
            _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"fold_menu_receiver\"><ul id=\"receiver\"></ul><div class=\"menu_arrow\"><button id=\"receiverClick\"><img src=\"static/images/angle-down-white.svg\" alt=\"\"></button></div></div>", 1))
          ])
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.industriesData, (industries, index) => {
        return (_openBlock(), _createElementBlock("section", {
          id: 'section' + industries.id,
          class: _normalizeClass(['big-picture-fold', index % 2 === 0 ? 'b-f-left' : 'b-f-right']),
          key: industries.id
        }, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("img", {
                src: _ctx.getCdnImageAddress(industries.industryImage, `w_575,h_457/`),
                alt: ""
              }, null, 8, _hoisted_13)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("h4", null, _toDisplayString(industries.title), 1),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("h5", null, [
                  _createElementVNode("p", {
                    innerHTML: industries.shortDescription
                  }, null, 8, _hoisted_16)
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("p", {
                    innerHTML: _ctx.getIndustriesDescription(industries)
                  }, null, 8, _hoisted_18)
                ])
              ]),
              (_ctx.shouldShowIndustriesReadMore(industries))
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("a", {
                      href: "javascript:void(0);",
                      id: "readMoewa",
                      onClick: ($event: any) => (_ctx.toggleIndustriesDescription(industries.id))
                    }, _toDisplayString(_ctx.isExpandedIndustries(industries.id) ? '<< Read Less' : 'Read More >>'), 9, _hoisted_20)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ], 10, _hoisted_10))
      }), 128))
    ]),
    _createVNode(_component_userFooter),
    _createVNode(_component_ChatbotPopup)
  ]))
}